import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "widget-lottery-card__decor",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "widget-lottery-card__ball widget-lottery-card__ball--hero" }
const _hoisted_3 = { class: "widget-lottery-card__hero" }
const _hoisted_4 = { class: "widget-lottery-card__hero-content" }
const _hoisted_5 = { class: "widget-lottery-card__identity" }
const _hoisted_6 = { class: "widget-lottery-card__flag-wrap" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "widget-lottery-card__names" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "widget-lottery-card__format-line" }
const _hoisted_11 = ["title"]
const _hoisted_12 = {
  class: "widget-lottery-card__badge",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "widget-lottery-card__footer" }
const _hoisted_14 = { class: "widget-lottery-card__countdown-label" }
const _hoisted_15 = {
  class: "widget-lottery-card__timer",
  "aria-live": "polite"
}
const _hoisted_16 = { class: "widget-lottery-card__unit" }
const _hoisted_17 = { class: "widget-lottery-card__unit" }
const _hoisted_18 = { class: "widget-lottery-card__unit" }
const _hoisted_19 = {
  key: 1,
  type: "button",
  class: "widget-lottery-card__bet",
  disabled: ""
}

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import type { UpcomingDraw } from '@/types/lottery'
import { getGameLogoUrl } from '@/utils/resultParser'
import {
  getWidgetCardDecor,
  getWidgetGameDisplayLines,
} from '@/utils/widgetCard'
import { iframeCommunication } from '@/utils/iframeCommunication'


export default /*@__PURE__*/_defineComponent({
  __name: 'WidgetLotteryCard',
  props: {
    lottery: {}
  },
  emits: ["remove"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const route = useRoute()
const router = useRouter()

const betClosed = ref(false)
const countdown = ref({ hours: 0, minutes: 0, seconds: 0 })

const flagUrl = computed(() =>
  getGameLogoUrl(props.lottery.game_logo, props.lottery.game_slug)
)

const displayLines = computed(() =>
  getWidgetGameDisplayLines(props.lottery.game_name)
)

const cardDecor = computed(() =>
  getWidgetCardDecor(props.lottery.game_slug || props.lottery.game_name)
)

const timeParts = computed(() => ({
  hours: String(countdown.value.hours).padStart(2, '0'),
  minutes: String(countdown.value.minutes).padStart(2, '0'),
  seconds: String(countdown.value.seconds).padStart(2, '0'),
}))

const updateCountdown = () => {
  if (!props.lottery?.cutoff) {
    countdown.value = { hours: 0, minutes: 0, seconds: 0 }
    return
  }

  const cutoffRaw = props.lottery.cutoff as string | Date
  const cutoffTime = typeof cutoffRaw === 'string'
    ? new Date(cutoffRaw.replace(' ', 'T'))
    : new Date(cutoffRaw)
  const diff = cutoffTime.getTime() - Date.now()

  if (diff <= 0) {
    countdown.value = { hours: 0, minutes: 0, seconds: 0 }
    return
  }

  countdown.value = {
    hours: Math.floor(diff / (1000 * 60 * 60)),
    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((diff % (1000 * 60)) / 1000),
  }
}

let timer: number | undefined

onMounted(() => {
  updateCountdown()
  timer = window.setInterval(updateCountdown, 1000)
})

onUnmounted(() => {
  if (timer) {
    window.clearInterval(timer)
  }
})

watch(
  () => props.lottery.cutoff,
  () => {
    updateCountdown()
  }
)

watch(
  () => [countdown.value.hours, countdown.value.minutes, countdown.value.seconds],
  ([hours, minutes, seconds]) => {
    if (hours === 0 && minutes === 0 && seconds === 0 && !betClosed.value) {
      betClosed.value = true
      window.setTimeout(() => {
        emit('remove', props.lottery)
      }, 3000)
    }
  }
)

const handleBet = () => {
  const payload = {
    gameSlug: props.lottery.game_slug,
    drawId: props.lottery.id,
    gameName: props.lottery.game_name,
    cutoff: props.lottery.cutoff,
    drawDate: props.lottery.draw_date,
  }

  if (iframeCommunication.isRunningInIframe()) {
    iframeCommunication.sendMessage('widget-bet', payload)
    return
  }

  router.push({
    path: `/lottery/${props.lottery.game_slug}`,
    query: { ...route.query, draw: String(props.lottery.id) },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["widget-lottery-card", {
      'widget-lottery-card--alternate': cardDecor.value.alternate,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(cardDecor.value.ballDigit), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: flagUrl.value,
              alt: _ctx.lottery.country || _ctx.lottery.game_name,
              class: "widget-lottery-card__flag",
              loading: "lazy"
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (displayLines.value.format)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", {
                    class: "widget-lottery-card__title-line",
                    title: _ctx.lottery.game_name
                  }, _toDisplayString(displayLines.value.title), 9, _hoisted_9),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(displayLines.value.format), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("h3", {
                  key: 1,
                  class: "widget-lottery-card__title widget-lottery-card__title--clamp",
                  title: _ctx.lottery.game_name
                }, _toDisplayString(displayLines.value.title), 9, _hoisted_11))
          ]),
          _createElementVNode("span", _hoisted_12, _toDisplayString(cardDecor.value.badgeDigit), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('widget.nextDrawStartsIn')), 1),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", _hoisted_16, _toDisplayString(timeParts.value.hours) + "h", 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "widget-lottery-card__sep" }, ":", -1)),
        _createElementVNode("span", _hoisted_17, _toDisplayString(timeParts.value.minutes) + "m", 1),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "widget-lottery-card__sep" }, ":", -1)),
        _createElementVNode("span", _hoisted_18, _toDisplayString(timeParts.value.seconds) + "s", 1)
      ]),
      (!betClosed.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "widget-lottery-card__bet",
            onClick: handleBet
          }, _toDisplayString(_ctx.$t('betslip.betNow')), 1))
        : (_openBlock(), _createElementBlock("button", _hoisted_19, _toDisplayString(_ctx.$t('betslip.betClosed')), 1))
    ])
  ], 2))
}
}

})